export default __webpack_public_path__ + "static/media/open.4b8fb1c0.wav";